import { night as NIGHT_COLORS } from '@eb/eds-settings';
import { genTheme } from '../_internal/utils';

export default genTheme(null, NIGHT_COLORS);
